import { useNavigate } from 'react-router-dom';

interface TopNavProps {
  title?: string;
}

export default function TopNav({ title = '' }: TopNavProps) {
  const navigate = useNavigate();

  return (
    <div className="sticky top-0 z-50 bg-white h-14 flex items-center border-b border-[#E8E2DA] lg:static lg:h-12 lg:bg-white lg:border-b lg:border-[#E8E2DA]">
      <div className="w-full flex items-center justify-between px-4 lg:px-0 lg:max-w-[1200px] lg:mx-auto">
        <button
          onClick={() => navigate(-1)}
          className="w-10 h-10 flex items-center justify-center text-[#121B35] active:scale-90 transition-transform lg:w-8 lg:h-8"
          aria-label="뒤로가기"
        >
          <i className="ri-arrow-left-s-line text-xl" />
        </button>

        <span className="absolute left-1/2 -translate-x-1/2 text-sm font-semibold text-[#121B35] truncate max-w-[60%] lg:text-xs lg:font-medium lg:static lg:translate-x-0 lg:ml-2">
          {title}
        </span>

        <div className="flex items-center gap-0.5">
          <button
            className="w-10 h-10 flex items-center justify-center text-[#121B35] active:scale-90 transition-transform lg:w-8 lg:h-8"
            aria-label="찜하기"
          >
            <i className="ri-heart-line" />
          </button>

          <button
            className="w-10 h-10 flex items-center justify-center text-[#121B35] active:scale-90 transition-transform lg:w-8 lg:h-8"
            aria-label="공유하기"
          >
            <i className="ri-share-line" />
          </button>
        </div>
      </div>
    </div>
  );
}